/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Grid, Row, Col } from 'react-bootstrap';
import { routerActions } from 'react-router-redux';
import Toolbar from 'loracoms/Toolbar';
import Nvl from 'loracoms/Nvl';
import PageLoading from 'loracoms/PageLoading';
import PageNoPerm from 'loracoms/PageNoPerm';
import IntlMsg from 'lorautils/intl/IntlMsg';
import DataPoints from './coms/DataPoints';

const propTypes = {
  appId: React.PropTypes.string.isRequired,
  intl: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
  appState: React.PropTypes.object.isRequired,
  planState: React.PropTypes.object.isRequired,
};

class DataPointsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      appState: props.appState,
      planState: props.planState,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.datapointsview');
  }

  componentWillReceiveProps(nextProps) {
    const { appState, planState } = nextProps;
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
    if (planState !== this.props.planState) {
      this.setState({ planState });
    }
  }

  render() {
    const { appId, pushState } = this.props;
    const {
      appState: {
        status = '',
        data: { name = '' } = {},
      },
      planState,
    } = this.state;

    if (planState.status === 'pending') {
      return <PageLoading />;
    }
    if (planState.data.tier === 1) {
      return <PageNoPerm />;
    }

    const breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
      onClick: () => pushState('/application'),
    }, {
      content: <Nvl status={status} val={name} />,
      active: true,
    }];
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            <Toolbar breadcrumb={breadcrumb} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <DataPoints appId={appId} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

DataPointsView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  appId: ownProps.params.id,
  appState: state.app.getApp,
  planState: state.billing.plan,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DataPointsView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DataPointsView/index.jsx